import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

const ValouseEspace = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [editHero, setEditHero] = useState(false);
  const [heroPosition, setHeroPosition] = useState({ x: 50, y: 10 });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    // Pour l'instant, on simule simplement une réussite locale
    setIsLoading(true);
    try {
      setIsSent(true);
      setHasError(false);
      window.location.href = "/valouse/espace/confirmation";
    } catch (error) {
      setHasError(true);
      setIsSent(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F7F2] relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover opacity-60"
        style={{ 
          backgroundImage: `url(https://customer-assets.emergentagent.com/job_cocon-customizer/artifacts/s7azwqj1_IMG_3570.HEIC)`,
          backgroundPosition: `${heroPosition.x}% ${heroPosition.y}%`
        }}
      />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#F9F7F2]/60 to-[#F9F7F2]" />

      {/* ═══ CONSERVATION TEMPORAIRE — Mode édition photo (outil dev, masqué en production) ═══
      <div className="absolute top-6 right-6 z-20 flex flex-col items-end gap-1">
        <button
          type="button"
          onClick={() => setEditHero(!editHero)}
          className="text-[0.6rem] tracking-[0.18em] uppercase px-3 py-1 rounded-full bg-[#3F2A24]/80 text-[#F3E5CF] shadow-sm hover:bg-[#6E3A1E]"
        >
          {editHero ? "Mode édition photo : ON" : "Mode édition photo : OFF"}
        </button>

        {editHero && (
          <div className="flex flex-col items-end gap-1 bg-[#3F2A24]/85 px-2 py-2 rounded-2xl text-[#F3E5CF] text-[0.6rem]">
            <div className="flex justify-between gap-2 w-full">
              <span className="tracking-[0.15em] uppercase opacity-80">Centrer la photo</span>
            </div>
            <div className="flex items-center justify-between gap-2">
              <div className="flex flex-col gap-1">
                <button
                  type="button"
                  onClick={() => setHeroPosition(pos => ({ ...pos, y: Math.max(20, pos.y - 3) }))}
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                  ↑ Haut
                </button>
                <button
                  type="button"
                  onClick={() => setHeroPosition({ x: 50, y: 65 })}
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                  • Centre
                </button>
                <button
                  type="button"
                  onClick={() => setHeroPosition(pos => ({ ...pos, y: Math.min(80, pos.y + 3) }))}
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                  ↓ Bas
                </button>
              </div>
              <div className="flex flex-col gap-1">
                <button
                  type="button"
                  onClick={() => setHeroPosition(pos => ({ ...pos, x: Math.max(20, pos.x - 3) }))}
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                  ← Gauche
                </button>
                <button
                  type="button"
                  onClick={() => setHeroPosition(pos => ({ ...pos, x: Math.min(80, pos.x + 3) }))}
                  className="px-2 py-1 rounded-full bg-[#6E3A1E] hover:bg-[#C5A059] hover:text-[#3F2A24]"
                >
                  Droite →
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      ═══ FIN CONSERVATION TEMPORAIRE ═══ */}

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6">
        <div className="max-w-md w-full animate-fade-in-up">
          {/* Logo/Brand */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#C5A059]/10 mb-6 animate-breathing">
              <Sparkles className="w-8 h-8 text-[#C5A059]" strokeWidth={1.5} />
            </div>
            <h1 className="font-serif text-4xl md:text-5xl text-[#3F2A24] mb-2 tracking-tight">
              COCON
            </h1>
            <p className="text-xs tracking-[0.35em] uppercase font-medium text-[#4B3329] mb-1">
              MON ESPACE NUMÉRIQUE
            </p>
            <p className="text-[0.65rem] tracking-[0.25em] uppercase font-medium text-[#8C6A4A]">
              DRÔME PROVENÇALE • SEPTEMBRE 2026
            </p>
          </div>

          {/* Divider */}
          <div className="divider-gold mb-10" />

          {!isSent && !hasError ? (
            <>
              {/* Intro Text */}
              <p className="text-center text-[#4B3329] mb-8 leading-relaxed">
                Cet espace est réservé aux âmes déjà inscrites à COCON Valouse.
              </p>
              <p className="text-center text-[#4B3329] mb-4 leading-relaxed">
                Pour y entrer, indique simplement ton email.<br />
                Un lien d’accès personnel te sera envoyé.
              </p>
              <p className="text-center text-[#C5A059] text-xs tracking-[0.35em] uppercase mb-6">
                ⸻
              </p>

              {/* Formulaire email */}
              <div className="h-8" />
              <form onSubmit={handleSubmit} className="space-y-6 max-w-md mx-auto">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="ton@email.com"
                  className="input-sacred text-center text-[#3F2A24] placeholder:text-[#8C6A4A]"
                  required
                />
                <button
                  type="submit"
                  disabled={isLoading}
                  className="btn-sacred w-full flex items-center justify-center gap-2"
                >
                  {isLoading ? (
                    <span>Envoi en cours...</span>
                  ) : (
                    <span>Recevoir mon lien d’accès</span>
                  )}
                </button>
              </form>
            </>
          ) : null}

          {isSent && !hasError && (
            <div className="text-center animate-fade-in-up mt-10">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#C5A059]/10 flex items-center justify-center">
                <svg className="w-8 h-8 text-[#C5A059]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </div>
              <h2 className="font-serif text-2xl text-[#3F2A24] mb-4">
                Merci pour ta demande 🤍
              </h2>
              <p className="text-[#4B3329] leading-relaxed mb-4">
                Jeinar va vérifier ton inscription à la retraite et t’envoyer ton lien d’accès personnel dans les plus brefs délais.
              </p>
              <p className="text-[#4B3329] leading-relaxed mb-4">
                Ce lien te permettra d’entrer dans ton espace,<br />
                simplement et en toute sécurité.
              </p>
              <p className="text-sm text-[#8C6A4A]">
                Tu peux maintenant fermer cette page en confiance.
              </p>
            </div>
          )}

          {hasError && (
            <div className="text-center animate-fade-in-up mt-10">
              <h2 className="font-serif text-2xl text-[#3F2A24] mb-4">
                Merci pour ta demande 🤍
              </h2>
              <p className="text-[#4B3329] leading-relaxed mb-4">
                À ce stade, ton inscription à la retraite n’apparaît pas comme validée.
              </p>
              <p className="text-[#4B3329] leading-relaxed mb-4">
                Si tu penses qu’il s’agit d’une confusion<br />
                ou si tu as besoin de clarifier ta situation,<br />
                n’hésite pas à nous écrire à :<br />
                <span className="font-semibold">exquisite.impactful.retreats@gmail.com</span>
              </p>
              <p className="text-sm text-[#8C6A4A]">
                Nous prendrons le temps de te répondre.
              </p>
            </div>
          )}

          {/* Lien de retour */}
          <div className="mt-16 text-center">
            <Link 
              to="/valouse"
              className="inline-flex items-center gap-2 text-sm text-[#8C6A4A] hover:text-[#C5A059] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>Retour à COCON Valouse</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValouseEspace;
